import { useEffect, useState } from "react";
import { X } from "lucide-react";

/**
 * Font lab – a review tool, not a product feature.
 * Open with `?fontlab=1` (stays open for the session), pick a display-font direction and it is applied
 * site-wide to the large type via `html[data-font]` and remembered in localStorage. `?font=<id>` also works.
 */
export const FONTS = [
  { id: "instrument", label: "Instrument Sans", note: "Dagens – nøytral, moderne" },
  { id: "schibsted", label: "Schibsted Grotesk", note: "Norsk, redaksjonell, karakter" },
  { id: "host", label: "Host Grotesk", note: "Presis, ingeniørmessig (Söhne/Suisse-retning)" },
  { id: "familjen", label: "Familjen Grotesk", note: "Svensk, solid, litt varme" },
  { id: "geist", label: "Geist", note: "Sveitsisk stramhet, teknisk" },
];

const KEY = "eqva-font";
const LAB = "eqva-fontlab";

export const applyFont = (id) => {
  const root = document.documentElement;
  if (!id || id === "instrument") { delete root.dataset.font; localStorage.removeItem(KEY); }
  else { root.dataset.font = id; localStorage.setItem(KEY, id); }
};

export const FontLab = () => {
  const [openLab, setOpenLab] = useState(false);
  const [font, setFont] = useState("instrument");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("fontlab")) sessionStorage.setItem(LAB, "1");
    const wanted = params.get("font") || localStorage.getItem(KEY) || "instrument";
    const valid = FONTS.some((f) => f.id === wanted) ? wanted : "instrument";
    applyFont(valid);
    setFont(valid);
    setOpenLab(sessionStorage.getItem(LAB) === "1");
  }, []);

  if (!openLab) return null;
  return (
    <div data-testid="fontlab" role="group" aria-label="Skriftvalg (testverktøy)" className="fixed bottom-5 left-5 z-[300] w-[min(92vw,380px)] border border-line bg-white/95 p-4 text-ink shadow-[0_8px_30px_rgba(8,28,48,0.12)] backdrop-blur">
      <div className="flex items-center justify-between gap-4">
        <p className="t-label text-muted">Skriftlab · display-type</p>
        <button type="button" aria-label="Lukk skriftlab" data-testid="fontlab-close" onClick={() => { sessionStorage.removeItem(LAB); setOpenLab(false); }} className="p-1 text-muted hover:text-ink"><X size={14} /></button>
      </div>
      <ul className="mt-3 grid gap-1">
        {FONTS.map((f) => (
          <li key={f.id}>
            <button
              type="button"
              data-testid={`fontlab-${f.id}`}
              aria-pressed={font === f.id}
              onClick={() => { applyFont(f.id); setFont(f.id); }}
              className={`flex w-full items-baseline justify-between gap-4 px-2 py-1.5 text-left text-[13px] transition-colors duration-150 ${font === f.id ? "bg-navy text-white" : "hover:bg-surface"}`}
            >
              <span className="font-medium">{f.label}</span>
              <span className={`text-[11px] ${font === f.id ? "text-white/70" : "text-muted"}`}>{f.note}</span>
            </button>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[11px] leading-snug text-muted">Valget lagres i denne nettleseren. Brødtekst og UI beholder Instrument Sans.</p>
    </div>
  );
};
